import React, { useState, useEffect } from "react";
import { useAuth } from "./AuthContext";
import Search from "./Search";
import AddPerson from "./AddPerson";
import PeopleList from "./PeopleList";
import "./Auth.css";

export default function Dashboard() {
  const { user, logout } = useAuth();
  const [stats, setStats] = useState({ totalPeople: 0, recentlyAdded: 0 });
  const [loading, setLoading] = useState(true);

  const getUserInitials = (name) => {
    return name
      .split(' ')
      .map(word => word[0])
      .join('')
      .toUpperCase()
      .slice(0, 2);
  };

  // Load dashboard stats
  useEffect(() => {
    const loadStats = async () => {
      try {
        const res = await fetch(`/api/people/all`, {
          credentials: 'include', // Include cookies for better-auth session
        });
        if (res.ok) {
          const people = await res.json();
          const now = new Date();
          const weekAgo = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
          
          const recentlyAdded = people.filter(person => {
            const createdAt = new Date(parseInt(person.createdAt || person._id.toString().substring(0,8), 16) * 1000);
            return createdAt > weekAgo;
          }).length;

          setStats({
            totalPeople: people.length,
            recentlyAdded
          });
        }
      } catch (err) {
        console.error("Error loading stats:", err);
      } finally {
        setLoading(false);
      }
    };

    loadStats();
  }, [user]);

  return (
    <div>
      <nav className="dashboard-nav">
        <h1>People Directory</h1>
        <div className="nav-user-info">
          <div className="user-avatar">
            {getUserInitials(user.name)}
          </div>
          <span style={{ color: '#4a5568', fontWeight: '500' }}>
            {user.name} {user.role === 'admin' && '(Admin)'}
          </span>
          <div className="nav-actions">
            <a href="/ai-search" className="ai-search-button" title="AI-Powered Search">
              🤖 AI Search
            </a>
            <a href="/settings/2fa" className="settings-button" title="Security Settings">
              🔒 Security
            </a>
            <button onClick={logout} className="logout-button">
              Logout
            </button>
          </div>
        </div>
      </nav>
      
      <div style={{ padding: '24px' }}>
        {/* Dashboard Stats */}
        <div className="dashboard-stats">
          <div className="stat-card">
            <div className="stat-number">{loading ? "..." : stats.totalPeople}</div>
            <div className="stat-label">Total People</div>
          </div>
          <div className="stat-card">
            <div className="stat-number">{loading ? "..." : stats.recentlyAdded}</div>
            <div className="stat-label">Added This Week</div>
          </div>
          <div className="stat-card">
            <div className="stat-number">📖</div>
            <div className="stat-label">CrossRef Papers Search</div>
          </div>
          <div className="stat-card">
            <div className="stat-number">🔍</div>
            <div className="stat-label">Enhanced Search</div>
          </div>
        </div>

        {/* Main Search Component */}
        <Search />
        
        {/* Admin Section */}
        {user.role === "admin" && (
          <div className="admin-section">
            <h3 style={{ 
              color: '#2d3748', 
              borderBottom: '2px solid #e2e8f0', 
              paddingBottom: '8px',
              marginBottom: '20px'
            }}>
              Admin Tools
            </h3>
            <AddPerson />
          </div>
        )}

        {/* People List Section */}
        <div className="people-section">
          <PeopleList />
        </div>
      </div>
    </div>
  );
}